import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import HomeIcon from '@material-ui/icons/Home'
import AddCircle from '@material-ui/icons/AddCircle'
import Build from '@material-ui/icons/Build'
import Info from '@material-ui/icons/Info'
import LibraryBooks from '@material-ui/icons/LibraryBooks'
import ContactMail from '@material-ui/icons/ContactMail'
import Storage from '@material-ui/icons/Storage'
import { Redirect } from 'react-router'
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
import Home from './components/pages/Home'
import About from './components/pages/About'
import Configuration from './components/pages/Configuration'
import NewDocument from './components/pages/NewDocument'
import Publications from './components/pages/Publications'
import LocalStorage from './components/pages/Storage'
import ContactUs from './components/pages/ContactUs'
import PositionedSnackbar from './components/Snackbar'
import Crate from 'crate-core'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { version } from './../package.json'

import styleCss from './App.module.css'
const drawerWidth = 240

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    background:
      'linear-gradient(to right bottom, #d63667, #e25b72, #ed797f, #f79691, #ffb2a6)',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
  content: {
    'margin-top': '40px',
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  }
})

class PersistentDrawerLeft extends React.Component {
  constructor() {
    super()
  }
  state = {
    open: false,
    page: 'Home'
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  setPage(page) {
    this.setState({ page: page })
  }

  render() {
    const { classes, theme } = this.props
    const { open } = this.state

    return (
      <HashRouter>
        <div className={classes.root}>
          <CssBaseline />
          <AppBar
            position="fixed"
            className={classNames(classes.appBar, {
              [classes.appBarShift]: open
            })}
          >
            <Toolbar disableGutters={!open}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <div className={styleCss.logo}>
                Soocrate
                <sub style={{ 'font-size': 'small' }}>V{version}</sub>
              </div>

              <IconButton
                color="inherit"
                className={{
                  display: 'flex',
                  alignItems: 'right',
                  position: 'absolute'
                }}
              />
            </Toolbar>
          </AppBar>
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
              paper: classes.drawerPaper
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={this.handleDrawerClose}>
                {theme.direction === 'ltr' ? (
                  <ChevronLeftIcon />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            </div>
            <Divider />
            <List>
              <ListItem button key="Home" component={Link} to="/">
                <ListItemIcon>
                  {' '}
                  <HomeIcon />{' '}
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItem>

              <ListItem
                button
                key="Storage"
                component={Link}
                to="/storage"
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon>
                  {' '}
                  <Storage />{' '}
                </ListItemIcon>
                <ListItemText primary="Storage" />
              </ListItem>

              <ListItem
                button
                key="New Document"
                component={Link}
                to="/document"
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon>
                  <AddCircle />
                </ListItemIcon>
                <ListItemText primary="New Document" />
              </ListItem>

              <ListItem
                button
                key="Configuration"
                component={Link}
                to="/configuration"
              >
                <ListItemIcon>
                  <Build />
                </ListItemIcon>
                <ListItemText primary="Configuration" />
              </ListItem>
            </List>
            <Divider />
            <List>
              <ListItem button key="About" component={Link} to="/about">
                <ListItemIcon>
                  <Info />
                </ListItemIcon>
                <ListItemText primary="About" />
              </ListItem>

              <ListItem
                button
                key="Publications"
                component={Link}
                to="/publications"
              >
                <ListItemIcon>
                  <LibraryBooks />
                </ListItemIcon>
                <ListItemText primary="Publications" />
              </ListItem>
              <ListItem
                button
                key="Contact us"
                component={Link}
                to="/contactus"
              >
                <ListItemIcon>
                  <ContactMail />
                </ListItemIcon>
                <ListItemText primary="Contact us" />
              </ListItem>
            </List>
          </Drawer>

          <main
            className={classNames(classes.content, {
              [classes.contentShift]: open
            })}
          >
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/about" component={About} />
              <Route
                exact
                path="/document"
                render={() => (
                  <Redirect to={'/document/' + Crate.getRandomId()} />
                )}
              />

              <Route
                exact
                path="/document/:documentId"
                component={NewDocument}
              />
              <Route exact path="/contactus" component={ContactUs} />
              <Route exact path="/configuration" component={Configuration} />
              <Route exact path="/storage" component={LocalStorage} />
              <Route exact path="/publications" component={Publications} />
            </Switch>
          </main>
          <PositionedSnackbar />
        </div>
      </HashRouter>
    )
  }
}

PersistentDrawerLeft.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

export default withStyles(styles, { withTheme: true })(PersistentDrawerLeft)
